var map = {
	"./bounce/blocks": 2251,
	"./calc/blocks": 2252,
	"./craft/agent/blocks": 2254,
	"./craft/code-connection/blocks": 2255,
	"./craft/designer/blocks": 2108,
	"./craft/simple/blocks": 2253,
	"./dance/blocks": 1713,
	"./eval/blocks": 2256,
	"./flappy/blocks": 2257,
	"./jigsaw/blocks": 2263,
	"./maze/blocks": 2268,
	"./p5lab/spritelab/blocks": 1410,
	"./sites/studio/pages/blocks": 2280,
	"./studio/blocks": 2119,
	"./turtle/blocks": 2276
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2736;